export const MY_TRIP = 'myTrip';
export const HIS_TRIP = 'hisTrip';
